import {
  GetDocumentsAskAISettingsRequest,
  GetDocumentsAskAISettingsResponse,
  UpdateDocumentsAskAISettingsRequest,
  UpdateDocumentsAskAISettingsResponse,
} from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_pb";

import { supportServiceConnectClient } from "../index";
import { RequestMetadata } from "api/types";
import { toUUID } from "helpers/s12-helpers";

export type GetDocumentsAskAISettingsParams = {
  orgId: string;
};

export const getDocumentsAskAISettings = async (
  { orgId }: GetDocumentsAskAISettingsParams,
  headers: Record<RequestMetadata, string>,
): Promise<GetDocumentsAskAISettingsResponse> => {
  const req = new GetDocumentsAskAISettingsRequest({
    orgId: toUUID(orgId),
  });

  return supportServiceConnectClient.getDocumentsAskAISettings(req, {
    headers,
  });
};

export type UpdateDocumentsAskAISettingsParams = {
  orgId: string;
  enabled: boolean;
};

export const updateDocumentsAskAISettings = async (
  { orgId, enabled }: UpdateDocumentsAskAISettingsParams,
  headers: Record<RequestMetadata, string>,
): Promise<UpdateDocumentsAskAISettingsResponse> => {
  const req = new UpdateDocumentsAskAISettingsRequest({
    orgId: toUUID(orgId),
    enabled,
  });

  return supportServiceConnectClient.updateDocumentsAskAISettings(req, {
    headers,
  });
};
